export default __webpack_public_path__ + "navigation-guide-device-notification-960-c88e6bd26b26c77d90f9160b0e5e6ed2.webp";